import { axios, API } from './config';

export const invoicesAPI = {
  getAll: async (status = null) => {
    const params = status ? { status } : {};
    const response = await axios.get(`${API}/invoices`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/invoices/${id}`);
    return response.data;
  },
  
  getByContract: async (contractId) => {
    const response = await axios.get(`${API}/invoices/contract/${contractId}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/invoices`, data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axios.put(`${API}/invoices/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/invoices/${id}`);
    return response.data;
  },

  addPayment: async (invoiceId, payment) => {
    const response = await axios.post(`${API}/invoices/${invoiceId}/payments`, payment);
    return response.data;
  },

  removePayment: async (invoiceId, paymentId) => {
    const response = await axios.delete(`${API}/invoices/${invoiceId}/payments/${paymentId}`);
    return response.data;
  },

  getStats: async () => {
    const response = await axios.get(`${API}/invoices/stats/summary`);
    return response.data;
  }
};
